package top.wcpe.allincore.dsl.compiler.source

/**
 * 源码位置（1-based 行列号 + 0-based UTF-16 偏移）。
 *
 * 在词法/语法/语义诊断中统一用此结构定位错误，亦可用于 AST 节点的 position 字段。
 */
data class SourcePosition(
    val line: Int,
    val column: Int,
    val offset: Int,
    val sourceId: String,
    val endOffset: Int,
) {
    /** 保留既有 JVM 三参数构造器。 */
    constructor(line: Int, column: Int, offset: Int) : this(line, column, offset, "", offset)

    /** 位置对应的 UTF-16 左闭右开范围。 */
    val range: SourceRange
        get() = if (sourceId.isEmpty() || offset < 0) SourceRange.NONE else SourceRange(sourceId, offset, endOffset)

    /** 返回起点不变、终点更新后的新位置。 */
    fun endingAt(end: Int): SourcePosition = SourcePosition(line, column, offset, sourceId, end)

    companion object {
        /** 占位位置，用于无法定位的合成节点。 */
        val UNKNOWN = SourcePosition(-1, -1, -1)

        /**
         * 根据文本与字符 offset 反推 line/column。
         *
         * - line 与 column 均为 1-based
         * - offset 为字符索引（基于 UTF-16 char 单位，与 [String] 的下标一致）
         * - 若 offset 越界则会 clamp 到合法范围
         */
        fun fromOffset(
            text: String,
            offset: Int,
            sourceId: String = "",
            endOffset: Int = offset,
        ): SourcePosition {
            val clamped = offset.coerceIn(0, text.length)
            val clampedEnd = endOffset.coerceIn(clamped, text.length)
            var line = 1
            var column = 1
            var i = 0
            while (i < clamped) {
                if (text[i] == '\n') {
                    line++
                    column = 1
                } else {
                    column++
                }
                i++
            }
            return SourcePosition(line, column, clamped, sourceId, clampedEnd)
        }
    }
}
